import { Row, Col, Form, Skeleton, Image, Typography, message } from "antd";
import { useNavigate } from 'react-router-dom';
import { InputText, SaveButton } from "@comps/components"
import { useSelector } from 'react-redux';
import { getProfileDetail, updatePassword } from "../requests";
import { trans } from "../../../../wrappers/components";
import { useEffect, useState } from "react";
import { makeRequestStateless } from '../../../../utils/helpers';
const { Title, Text } = Typography;

const languageKey = "profile";

const ProfileForm = () => {
  const [form] = Form.useForm();
  const authUser = useSelector((state) => state.auth.authUser);
  const [loader, setLoader] = useState(false);
  const [profile, setProfile] = useState();
  const [updatedData, setUpdatedData] = useState();
  const navigate = useNavigate();


  useEffect(() => {
    if (authUser) {
      setLoader(true);
      makeRequestStateless(
        getProfileDetail, authUser, onProfileSuccess, onProfileFailure);
    }
  }, [authUser]);

  const onProfileSuccess = (res) => {
    setProfile(res);
    setLoader(false);
  }

  const onProfileFailure = (err) => {
    console.error("Failed to fetch profile data", err);
    setLoader(false);
  }

  const onFinish = (values) => {
    if (!values.currentPassword || !values.newPassword || !profile.uuid) {
      return;
    }

    setLoader(true);
    const payload = {
      newPassword: values.newPassword,
      currentPassword: values.currentPassword,
      uuid: profile.uuid,
    };

    makeRequestStateless(updatePassword, payload, onChangeSuccess, onChangeFailure);
  };

  const onChangeSuccess = (res) => {
    setLoader(false);
    localStorage.clear();
    window.location.href = "/";
  }

  const onChangeFailure = (err) => {
    message.error(err)
    setLoader(false);
  }

  const onChangeData = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.id.split("_")[1]]: e.target.value,
    });
  };

  const rules = {

    fullname: [
      { required: true, message: trans(`${languageKey}.fullname`) },
    ],

    email: [
      { required: true, message: trans(`${languageKey}.email`) },
    ],

    currentPassword: [
      { required: true, message: trans(`${languageKey}.currentPassword.required`) },
      { min: 8, message: trans(`${languageKey}.currentPassword.minlength`) },
    ],

    newPassword: [
      { required: true, message: trans(`${languageKey}.newPassword.required`) },
      { min: 8, message: trans(`${languageKey}.newPassword.minlength`) },
    ],

    confirmPassword: [
      { required: true, message: trans(`${languageKey}.confirmPassword.required`) },
      { min: 8, message: trans(`${languageKey}.confirmPassword.minlength`) },
      {
        validator: (_, value) => {
          if (!value || form.getFieldValue('newPassword') === value) {
            return Promise.resolve();
          }
          return Promise.reject(trans(`${languageKey}.passwordsMismatch`));

        }
      }
    ],

  };

  if (loader || !profile) {
    return <Skeleton active />;
  }

  return (
    <div className="make-center-profile">
      <Row gutter={ 24 }>
        <Col md={ 24 } lg={ 8 }>
          <div className="image">
            <Image
              preview={ { visible: false } }
              width={ 200 }
              height={ 200 }
              src="https://i.imgur.com/2gSHyzC.jpeg"
              fallback="https://media.istockphoto.com/vectors/image-preview-icon-picture-placeholder-for-website-or-uiux-design-vector-id1222357475"
            // if you still want zoom functionality, add antd Image.PreviewGroup
            />
            <Title level={ 5 }>{ authUser }</Title>
            <Text type="secondary">{ authUser }</Text>
          </div>
        </Col>

        <Col md={ 24 } lg={ 16 }>
          <Skeleton loading={ loader }>
            <Form
              form={ form }
              scrollToFirstError
              className="pos-form"
              size="large"
              onFinish={ onFinish }
            >
              <Form.Item
                name="fullname"
                label={ trans("profile.fullname") }
                initialValue={ profile.username }
                rules={ rules.fullname }
                className="da-mb-16"
              >
                <InputText disabled />
              </Form.Item>

              <Form.Item
                name="email"
                rules={ rules.email }
                label={ trans("profile.email") }
                initialValue={ profile.email }
                className="da-mb-16"
              >
                <InputText disabled />
              </Form.Item>

              <Form.Item
                name="currentPassword"
                label={ trans("profile.currentPassword") }
                className="da-mb-16"
                rules={ rules.currentPassword }
              >
                <InputText type="password" onChange={ onChangeData } />
              </Form.Item>

              <Form.Item
                name="newPassword"
                label={ trans("profile.newPassword") }
                rules={ rules.newPassword }
                className="da-mb-16"
              >
                <InputText type="password" onChange={ onChangeData } />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label={ trans("profile.confirmPassword") }
                rules={ rules.confirmPassword }
                className="da-mb-16"
              >
                <InputText type="password" />
              </Form.Item>

              <Form.Item shouldUpdate className="da-mt-24">
                <SaveButton
                  className="actionButton"
                  htmlType="submit"
                  trans="auth.saveProfile"
                />
              </Form.Item>
            </Form>
          </Skeleton>
        </Col>
      </Row>
    </div>
  );
};

export default ProfileForm;
